/**
 * @name WorkAnniversaries
 * @description Componente de próximos aniversarios laborales
 * @author César Rivera
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import moment from 'moment';
import styled from 'styled-components';

import { EmployeeDetail } from '@components';
import { Card, Icons, MUI, Typography } from '@styles';

const WorkAnniversaries = (props) => {
  const {
    anniversaries,
    onOpen,
  } = props;

  const month = new Date().getMonth();
  const today = moment().format('DD/MM');
  const tomorrow = moment().add(1, 'd').format('DD/MM');

  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
  ];

  // Próximos aniversarios laborales
  const nextAnniversaries = anniversaries.filter((item) => moment(item.FechaAniversario).format('DD/MM') >= today);

  return (
    <>
      <Card.Header divider>
        <Card.HeaderTitle>
          <Typography.H5>{`${i18n.t('Home.anniversariesMonth')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}</Typography.H5>
        </Card.HeaderTitle>
        {anniversaries.length !== 0 && (
          <Card.HeaderAction>
            <MUI.Tooltip title={<Trans>GenericMessages.seeAll</Trans>}>
              <MUI.ButtonIcon onClick={onOpen}>
                <Icons.MoreHoriz />
              </MUI.ButtonIcon>
            </MUI.Tooltip>
          </Card.HeaderAction>
        )}
      </Card.Header>

      <Card.Content scroll>
        {nextAnniversaries.length !== 0 ? (
          nextAnniversaries.map((item, index) => {
            let workDate = moment(item.FechaAniversario).format('DD/MM');

            if (workDate === today) {
              workDate = i18n.t('Home.today');
            } else if (workDate === tomorrow) {
              workDate = i18n.t('Home.tomorrow');
            } else {
              workDate = moment(item.FechaAniversario).format(i18n.t('FormatDates.birthday'));
            }

            let seniority = `${item.Antiguedad} ${i18n.t('GenericMessages.years').toLowerCase()}`;

            return (
              <BoxRow key={index}>
                <WorkAnnEmployee>
                  <EmployeeDetail
                    avatar={item.Foto}
                    avatarSize="xs"
                    employeeName={item.Nombres}
                    employeeDetail={item.Area}
                  />
                </WorkAnnEmployee>
                <WorkAnnDay>
                  <Typography.Text>
                    <Typography.Small>
                      {`${workDate} (${seniority})`}
                    </Typography.Small>
                  </Typography.Text>
                </WorkAnnDay>
              </BoxRow>
            );
          })
        ) : (
            <BoxNotFound>
              <Icons.Info />
              <Typography.H6>{`${i18n.t('Home.noAnniversariesFound')} ${i18n.t(`Months.${[monthNames[month]]}`)}`}</Typography.H6>
            </BoxNotFound>
          )}
      </Card.Content>
    </>
  );
};

WorkAnniversaries.propTypes = {
  // Array con la información de los aniversarios laborales del mes.
  anniversaries: PropTypes.array.isRequired,
  // Función que se ejecuta para abrir el modal.
  onOpen: PropTypes.func.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxRow = styled.div`
  padding: 8px;
  display: flex;
`;

const BoxNotFound = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;

  .MuiSvgIcon-root {
    margin-right: 12px;
    font-size: 20px;
  }
`;

const WorkAnnEmployee = styled.div`
  width: 70%;
`;

const WorkAnnDay = styled.div`
  width: 30%;
  padding: 8px;
  align-self: center;
  text-align: end;

  & > p {
    color: ${(props) => props.theme.colors.blueMedium};
  }
`;

export default WorkAnniversaries;